'use strict'

var Marionette = require('marionette')
var App = require('app')
var DialogComponent = require('src/components/dialog-view')
var Moment = require('moment')

/**
 * Dialog body view
 * -----------------------------------------------------------------------------
 * Body of the dialog
 */
var DialogBody = DialogComponent.Body.extend({
  template: require('./templates/body.html'),
  events: {
    'blur .js-time-input': 'onBlur'
  },
  /**
   * reformats the time for users convenience
   * @param  {[type]} ev [description]
   * @return {[type]}    [description]
   */
  onBlur: function (ev) {
    var convertPartToTime = function (time) {
      var timeInt = parseInt(time)
      if (isNaN(timeInt)) timeInt = 0

      if (timeInt < 10) return '0' + timeInt
      return timeInt
    }

    var value = ev.currentTarget.value

    // when not : is set
    if (value.indexOf(':') === -1) {
      var position = 1
      value = value.substr(0, position + 1) + ':' + value.substr(position)
    }
    var splitValue = value.split(':')

    var newValue = [convertPartToTime(splitValue[0]), convertPartToTime(splitValue[1])].join(':')
    ev.currentTarget.value = newValue.substr(0, 5)
  },
  templateContext: function () {
    return {
      getAttribute: App.TemplateHelpers.getAttribute,
      getDeviceTypes: App.TemplateHelpers.getDeviceTypes,
      getClients: App.TemplateHelpers.getClients,
      userHasRole: App.TemplateHelpers.userHasRole,
      formatTime: App.TemplateHelpers.formatTime
    }
  }
})

/**
 * Dialog view
 * -----------------------------------------------------------------------------
 * The dialog view
 */
var DialogView = DialogComponent.Layout.extend({
  className: 'dialog dialog-client-edit',
  onRender: function () {
  	var bodyView = new DialogBody({model: this.model, collection: this.collection})
  	this.showChildView('bodyRegion', bodyView)
  }
})

module.exports.Layout = DialogView



// WEBPACK FOOTER //
// ./js/modules/page-clients/edit_new/view.js